<template>
  <div>
    <Header :esSearch='keywords'/>
    <Navigationzj/>
    <div class="hxq_subpage">
      <div class="hxq_ppsp">
        <div class="hxq_fllb_sx">
          <div class="hxq_fllb_sx_yx">
            <div class="hxq_yzjk_mbx">
              <a href="/" class="allResult">首页<span class="newspan">></span></a>
              以下是为您找到与<span style="width: auto;color: blue;font-size: 13px;">"{{keywords}}"</span>相关的结果
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="news_list w1200" v-loading="qyloading">
      <ul>
        <li v-for="(item, index) in list" :key="index">
          <router-link :to="{path: '/InfoDetail', query:{id:item.id}}" target="_blank" :title="item.title">
          <div class="padd clearfix">
            <div class="news_list_l">
              <el-image
                :src="item.filename"
                fit="fill"
                style="width:130px;height:130px"
                >
                <div slot="error" class="image-slot">
                  <img src="../../assets/images/zwtp.jpg" width="130" height="130"/>
                </div>
              </el-image>
            </div>
            <div class="news_list_r">
              <h3 class="atpresent_title" v-html="hightLightText(item.title)"></h3>
              <div class="news_list_c clearfix">
                <em><img src="">{{item.addtime}}</em>
                <em><img src=""> {{item.hit}}次</em>
              </div>
              <div class="news_list_b" v-html="hightLightText(escapeHTML(item.content))"></div>
            </div>
          </div>
          </router-link>
        </li>
      </ul>
      <div class="cght_cnxhtiwtjsp" v-if="list.length==0">
        <div>
          <em class="myemptydata">暂无数据</em>
        </div>
      </div>
    </div>
    <div class="hxq_subpage">
      <pagination v-show="total>10" :total="total" :page.sync="listQuery.page" :limit.sync="listQuery.limit" @pagination="LoadData" />
    </div>
    <Footer/>
  </div>
</template>
<script>

import api from '@/api/resources'
import Header from '@/components/Resources/Header'
import Footer from '@/components/Footer'
import vuelist from '@/utils/vue_list'
import Navigationzj from '@/components/Navigationzj'
import Pagination from '@/components/Pagination'

export default {
  name: 'IndustryList',
  mixins: [vuelist],
  inject: ['reload'], // 注入依赖 实现页面刷新
  components: {
    Header,
    Navigationzj,
    Footer,
    Pagination
  },
  data () {
    return {
      api,
      keywords: this.$route.query.keywords,
      listQuery: {
        limit: 10,
        order: 'order_num',
        sort: 'asc',
        moduleid: this.$route.query.searchType,
        state: 'home'
      },
      qyloading: false
    }
  },
  watch: {
    $route (to, from) {
      this.reload()
    }
  },
  mounted () {
    if (this.keywords) {
      this.listQuery.search = this.keywords
      this.LoadData()
    }
  },
  methods: {
    escapeHTML (untrusted) {
      return untrusted.replace(/<(?:.|\n)*?>/gm, '')
        .replace(/(&rdquo;)/g, '/"')
        .replace(/&ldquo;/g, '/"')
        .replace(/&mdash;/g, '-')
        .replace(/&nbsp;/g, '')
        .replace(/&gt;/g, '>')
        .replace(/&lt;/g, '<')
        .replace(/<[\w\s"':=/]*/, '')
    },
    hightLightText (text) {
      if (text) {
        const reg = new RegExp(this.keywords, 'gi')// 动态正则表达式
        return text.replace(reg, `<span style="color:#e50000">${this.keywords}</span>`)// 使用replace替换
      }
    }
  }
}
</script>
<style scoped>
  .cght_cnxhtiwtjsp{ height:167px; width:100%; padding-top:175px;}
  .cght_cnxhtiwtjsp div{ width:144px; text-align:center; padding-left:100px; background:url(../../assets/images/spsc_img02.png) no-repeat left center; height:60px; line-height:60px;font-size:18px; color:#959595; margin:0px auto; clear:both;}
  .myemptydata {color:#959595}
  .atpresent_title{
    font-weight: 600;
  }
</style>



// WEBPACK FOOTER //
// src/view/resources/search_list.vue